export default __webpack_public_path__ + "static/media/call-center.0c3d2481.jpg";